import {
  UserLogin,
  UserLoginFail,
  UserLoginSuccess,
  UserLogout,
  UserLogoutSuccess,
  UserProfileLoadSuccess
} from "@state/user/user.actions";
import { inject, Injectable } from "@angular/core";
import { Action, State, StateContext, StateToken } from "@ngxs/store";
import { OidcSecurityService, UserDataResult } from "angular-auth-oidc-client";
import {firstValueFrom} from "rxjs";

export interface UserStateModel {
  isLoggedIn: boolean;
  userProfile: UserDataResult | null;
}

export const initialState: UserStateModel = {
  isLoggedIn: false, userProfile: null
};

export const USER_STATE_TOKEN: StateToken<UserStateModel> = new StateToken<UserStateModel>('user')

@State<UserStateModel>({
  name: USER_STATE_TOKEN, defaults: {
    ...initialState
  }
})
@Injectable()
export class UserState {

  oidcSecurityService = inject(OidcSecurityService);

  @Action(UserLogin) userLogin(ctx: StateContext<UserStateModel>) {
    if (this.oidcSecurityService.authenticated().isAuthenticated) {
      return ctx.dispatch(new UserLoginSuccess(this.oidcSecurityService.authenticated().isAuthenticated))
    } else return ctx.dispatch(new UserLoginFail('user_not_connected'));

  }

  @Action(UserLoginSuccess) userLoginSuccess(ctx: StateContext<UserStateModel>, { connected }: UserLoginSuccess) {
    ctx.patchState({
      isLoggedIn: connected
    })
    ctx.dispatch(new UserProfileLoadSuccess(this.oidcSecurityService.userData()));
  }

  @Action(UserProfileLoadSuccess) userProfileLoadSuccess(ctx: StateContext<UserStateModel>, { user }: UserProfileLoadSuccess) {
    ctx.patchState({
      userProfile: user
    })
  }

  @Action(UserLogout) userLogout(ctx: StateContext<UserStateModel>) {
    return firstValueFrom(this.oidcSecurityService.logoff()).then(() => {
      ctx.dispatch(new UserLogoutSuccess())
    })
  }

  @Action(UserLogoutSuccess) userLogoutSuccess(ctx: StateContext<UserStateModel>) {
    ctx.setState({
      isLoggedIn: false, userProfile: null
    })
  }

}
